<template>
  <v-row justify='center'>
    <v-dialog
      v-model='showDeleteModal'
      persistent
      max-width='500'
    >
      <v-card>
        <v-card-title class='headline'>
          Confirmar exclusão
        </v-card-title>
        <v-card-text>Tem certeza que deseja excluir {{ listName }} ?</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click='deleteUserList(index, listName)'
          >
            Confirmar
          </v-btn>
          <v-btn
            color='primary'
            @click='cancel()'
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import firebase from '@/api/firebase'

export default {
  name: 'ConfirmDeleteModal',
  props: {
      user: {
        type: Object,
        default: new Object()
      },
  },
  data () {
    return {
      showDeleteModal: false,
      listName: '',
      index:0,
    }
  },
  methods: {
    open (index, listName) {
      this.listName = listName
      this.index = index
      this.showDeleteModal = true
    },
    cancel () {
      this.showDeleteModal = false
    },
    deleteUserList(index, listName) {
      let params = {
        'userId': this.user.uid,
        'listName': listName
      }
      firebase.deleteUserList(params)
      this.user.lists.splice(index, 1)
      this.cancel()
      this.$bus.$emit('update-xp-list')
    }
  },
}
</script>
